/// <reference path="../../../exported/ajaxUtils.d.ts" />

import React = require("react");
import {Loader} from "../../components/Utils/loader/Loader";
import {PredictiveMaintenanceQuestionnaire} from "./PredictiveMaintenanceQuestionnaire";
import "./PredictiveMaintenanceWizard.scss";
import {defaultTheme} from "@vebox/etui-themes";
import {ThemeProvider} from "@vebox/etui-system";
import {veboxDefaultTheme} from "../../index";

const DEVICE_GUID_URL = "deviceGuid";

interface PredictiveMaintenanceWizardProps {
    componentId: number;
    stackManager: any;
    alarmId: number;
    alarmData: any;
    alarmPanel: any;
}

interface PredictiveMaintenanceWizardState {
    deviceGuid: string;
}

interface ServerRequestDeviceGuid {
    componentId: number;
}

export class PredictiveMaintenanceWizard
    extends React.Component<PredictiveMaintenanceWizardProps, PredictiveMaintenanceWizardState> {
    constructor(props: PredictiveMaintenanceWizardProps) {
        super(props);
        this.state = {
            deviceGuid: null,
        };
        this.retrieveDeviceGuid = this.retrieveDeviceGuid.bind(this);
    }

    public componentDidMount(): void {
        this.retrieveDeviceGuid();
    }

    public render() {
        let element;
        if (this.state.deviceGuid == null) {
            element = (
                <div id="alarmPanelQuestionnaire" className="alarmPanelQuestionnaire" style={{width: "450px"}}>
                    <div id="alarmPanelQuestionnaireSlider" className="alarm-panel-questionnaire-slider">
                        <div className="alarmPanelQuestion alarmPanelTerminalQuestionTitleContent">
                            <Loader/>
                        </div>
                    </div>
                </div>
            );
        } else {
            element = <PredictiveMaintenanceQuestionnaire
                deviceGuid={this.state.deviceGuid}
                stackManager={this.props.stackManager}
                componentId={this.props.componentId}
                alarmId={this.props.alarmId}
                alarmData={this.props.alarmData}
                alarmPanel={this.props.alarmPanel}
            />
        }
        return (
            <ThemeProvider theme={veboxDefaultTheme}>
                {element}
            </ThemeProvider>
        );
    }

    private retrieveDeviceGuid() {
        const params: ServerRequestDeviceGuid = {componentId: this.props.componentId};
        if (this.state.deviceGuid == null) {
            Ajax.vbxAjax({
                url: DEVICE_GUID_URL,
                data: params,
                type: "POST",
                cache: false,
                success: (response: string) => {
                    if (response != null) {
                        this.setState({deviceGuid: response});
                    }
                },
            });
        }
    }
}
